import React from "react";


 

const FancyFeatureTewentyTwo = ({FeatureContent}) => {
  return (
    <>
      {FeatureContent.map((val, i) => (
        <div
          className="col-lg-4 col-md-6 mb-30 "
       
          key={i}
        >
          <div className="block-style-twentyTwo pt-2  bg-light shadow mt-0 pb-2 px-3 h-100 ">
            <div
              className="icon d-flex align-items-center  justify-content-center mt-1"
             
            >
              <img src={val.icon} alt="icon" className="" />
            </div>
            <h4 className="h3-heading py-2 mt-1 fw-semibold">{val.title}</h4>
            <p className="h3-para lh-base">{val.subTitle}</p>
          </div>
   
        </div>
      ))}
    </>
  );
};

export default FancyFeatureTewentyTwo;
